import React, { Component } from 'react';
import logo from "../../images/logo.png";
import * as Utils from '../../inc/Utils.js'
import * as Icon from 'react-bootstrap-icons/dist/index';
import { Container, Form, Button, InputGroup, Modal, Alert, Spinner } from 'react-bootstrap/esm/index';
import {Config} from '../../Config'
import moment from "moment-timezone";

export default class Login extends Component {

    btnTextDefault = 'เข้าสู่ระบบ';
    btnTextLoading = 'เข้าสู่ระบบ..';
    
    openEyeStyle = {
        right: 10,
        top: 7,
        cursor: 'pointer'
    };
    
    constructor() {
        super();
        this.state = {
            isOpenEye: false,
            isShowModal: false,
            modalTitle: 'แจ้งเตือน',
            modalMessage: '....',
            inputEmail: '',
            inputPassword: '',
            btnDisable: false,
            btnText: this.btnTextDefault
        };
    }
    
    render() {
        return (
            <>
            <Container className="login">
                <h5 className="text-center text-danger">Social Tag Management</h5>
                <Form className="form-login rounded bg-white p-4 shadow">
                    <div className="text-center"><img src={logo} height="64" alt="" /></div>
                    <h6 className="text-center mt-3">ลงชื่อเข้าใช้งาน</h6>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" name="inputEmail" value={this.state.inputEmail} onChange={this.handleChange} autoComplete="off" minLength={4} maxLength={100} />
                    </Form.Group> 
                    <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>รหัสผ่าน</Form.Label>
                        <div className="position-relative">
                            <Form.Control type={this.state.isOpenEye ? 'text' : 'password'} name="inputPassword" value={this.state.inputPassword} onChange={this.handleChange} autoComplete="off" minLength={6} maxLength={20} />
                            <div className="position-absolute" style={this.openEyeStyle} onClick={this.openEye}>
                            {this.state.isOpenEye ? <Icon.Eye /> : <Icon.EyeSlash />}
                            </div>
                        </div>
                    </Form.Group>
                    <Button onClick={this.checkForm} variant="primary" className="w-100 btn-lg py-2" type="button" disabled={this.state.btnDisable}><Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className={this.state.btnDisable ? 'd-inline-block' : 'd-none'} /> {this.state.btnText}</Button>
                </Form> 
                <p className="text-muted text-center small mt-3">© AP</p>
            </Container> 
            <Modal show={this.state.isShowModal} onHide={this.handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{this.state.modalMessage}</Modal.Body> 
            </Modal>
            </>
        ) 
    } 
    
    openEye = () => { 
        this.setState({
            isOpenEye: !this.state.isOpenEye
        });
    };
    
    checkForm = () => {
        let isValidate = false;
        let message = '';
        let detail = '';
        
        if(!this.state.inputEmail || !Utils.validateEmail.test(this.state.inputEmail)) {
            message = 'กรุณาระบุ Email ให้ถูกต้อง';
            detail = <p className="mb-0">* เช่น your@email.com</p>
        }
        else if(!this.state.inputPassword || !Utils.strengthPassword.test(this.state.inputPassword)) {
            message = 'กรุณาระบุ รหัสผ่าน';
            detail = <p className="mb-0">* ต้องประกอบไปด้วย <br />- ภาษาอังกฤษ<br />- ตัวเล็ก/ตัวใหญ่<br />- อย่างน้อย 6-20 ตัวอักษร</p>
        }
        else { 
            isValidate = true;
        }
        
        if(isValidate) {
            //Check API
            this.setState({
                btnDisable: true,
                btnText: this.btnTextLoading,
            });

            const body = {
                email: this.state.inputEmail,
                password: this.state.inputPassword,
                latestLoginAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
            };
            fetch(Config.url.API_URL +'/api/auth/signIn', {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                'Content-Type':'application/json'
            }
            }).then(response =>{
                return response.json()
            }).then(result => {
                if(result.id) {
                    // this.setState({
                    //     btnDisable: true,
                    //     btnText: this.btnTextLoading,
                    //     isShowModal: true,
                    //     modalMessage: <Alert variant="success"><h5><Icon.Check2Circle /> Ok, Successfully</h5></Alert>
                    // });
                    localStorage.setItem(Utils.LOCAL_STORAGE_KEY, JSON.stringify(result));
                    window.location.reload();
                }
                else {
                    this.setState({
                        btnDisable: false,
                        btnText: this.btnTextDefault,
                        isShowModal: true,
                        modalMessage: <Alert variant="danger"><h5><Icon.InfoCircle /> ไม่สามารถ เข้าระบบได้ในขณะนี้</h5>กรุณาตรวจสอบ Email และรหัสผ่านอีกครั้ง<br />{result.message}</Alert>
                    });
                }
            }).catch(err => {
                alert(err)
            });
        }
        else {
            this.setState({ 
                isShowModal: true,
                modalMessage: <Alert variant="danger"><h5><Icon.InfoCircle /> {message}</h5>{detail}</Alert>
            })
        }
    }
    
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleShowModal = () => {
      this.setState({ isShowModal: true })
    };
  
    handleCloseModal = () => {
      this.setState({ isShowModal: false })
    };
} 